import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FlexRow, FlexColumn, FlexItem} from '@components/layout/FlexStyles';
import { TextTitle, TextTiny, TextSmall } from '@components/elements/TextStyles';

const debug = false;
const CreditsCard = (props) => {
  const { card, values } = props;
  debug && console.log("HomeCard", props);

  // get value from values property if present
  const getValue = (field) => {
    if (!values) {
      return '';
    }
    debug && console.log("values: ", values, " field:", field);
    return Object.hasOwn(values, field) ? values[field] : '';
  }

  // create the content of the card
  const getCardContent = () => {
    return(
      <FlexRow width={'100%'} height={'100%'} h_centered v_centered>
        <FlexItem>{card.icon}</FlexItem>
        <FlexItem>
          <FlexColumn>
            <FlexItem><TextTitle color={'primary'}>{ card.data ? getValue(card.data) : '+++' }</TextTitle></FlexItem>
            <CardText>{ card.title }</CardText>
          </FlexColumn>
        </FlexItem>
      </FlexRow>
    )
  }

  return(
      <StyledCard>
        { card.hasLink ?
          <StyledLink to={card.link}>
            <LinkedContent>
              { getCardContent() }
            </LinkedContent>
          </StyledLink>
          :
          <Content>
            { getCardContent() }
          </Content>
        }
      </StyledCard>
  )
};

export default CreditsCard;

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 10px;
  height: max-content;
  width: 100%;
  border-radius: 15px;
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 12px 5px;
  border-radius: 15px;
  background-color: ${(p) => p.theme.palette.backgroundTertiary};
  border: 1px solid ${(p) => p.theme.palette.accentSecondary};
`;

const LinkedContent = styled(Content)`
  display: flex;
  :hover {
    background-color: ${(p) => p.theme.palette.backgroundQuaternary };
  }
`;

const StyledLink = styled(Link)`
  width: 100%;
  height: 100%;
  border-radius: 15px;
`;

const CardText = styled.div`
  display: flex;
  font-size: 12px;
  color: ${(p) => p.theme.palette.accentPrimary};
`;
